module.exports = __webpack_public_path__ + "img/block.ea1dd9f9.svg";